import { Component } from '@angular/core';
import { Message } from 'primeng/api';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { AuthRoles } from 'src/app/auth/auth.types';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'ness-manage-supervisors',
  templateUrl: './manage-supervisors.component.html'
})
export class ManageSupervisorsComponent {
  loadingSupervisors: boolean = false;
  loadingNonSupervisors: boolean = false;
  private _eventStream$ = new BehaviorSubject(undefined);
  cgicSupervisors$: Observable<ServerModels.SupervisorsView[]> = this._eventStream$.pipe(
    switchMap(() => {
      this.loadingSupervisors = true;
      return this.adminService.getAllSupervisors().pipe(tap(() => this.loadingSupervisors = false));
    })
  );
  cgicNonSupervisors$: Observable<ServerModels.SupervisorsView[]> = this._eventStream$.pipe(
    switchMap(() => {
      this.loadingNonSupervisors = true;
      return this.adminService.getAllNonSupervisors().pipe(tap(() => this.loadingNonSupervisors = false));
    })
  );
  hasNESSAdmin: AuthRoles[] = ['NESS Administrator'];
  msgs: Message[];

  private _addSupervisors: ServerModels.SupervisorsView[] = [];
  private _removeSupervisors: ServerModels.SupervisorsView[] = [];

  constructor(private adminService: AdminService) { }

  onAddSupervisor(evt: { items: ServerModels.SupervisorsView[] }): void {
    this._addSupervisor(evt.items);
  }

  onRemoveSupervisor(evt: { items: ServerModels.SupervisorsView[] }): void {
    this._removeSupervisor(evt.items);
  }

  onSaveChanges(): void {
    const updatedSupervisors = [].concat(this._addSupervisors, this._removeSupervisors);
    this.adminService.addOrUpdateSupervisor(updatedSupervisors).subscribe({
      next: (messages:number) => {
        this.msgs = [{ severity: 'info', summary: 'Completed', detail: 'Update supervisors completed.' }]
      },
      complete: () => {
        this._addSupervisors = [];
        this._removeSupervisors = [];
        this._eventStream$.next(undefined);
      },
      error: (err:any) => {
        this.msgs = [{ severity: 'error', summary: 'Error Message', detail: 'An error occurred updating supervisors. Please try again later.' }]
      }
    });

  }

  private _addSupervisor(items: ServerModels.SupervisorsView[]): void {
    this._addSupervisors = this._addSupervisors.concat(items).filter((val, index, self) => self.indexOf(val) >= index);
    this._addSupervisors.forEach(x => x.Active = true);
    items.forEach((val, idx, self) => {
      let startIndex = this._removeSupervisors.indexOf(val);
      if (startIndex > -1) {
        this._removeSupervisors.splice(startIndex, 1);
      }
    });
  }

  private _removeSupervisor(items: ServerModels.SupervisorsView[]): void {
    this._removeSupervisors = this._removeSupervisors.concat(items).filter((val, index, self) => val.SupervisorCGICID && self.indexOf(val) >= index);
    this._removeSupervisors.forEach(x => x.Active = false);
    items.forEach((val, idx, self) => {
      let startIndex = this._addSupervisors.indexOf(val);
      if (startIndex > -1) {
        this._addSupervisors.splice(startIndex, 1);
      }
    });
  }
}
